<script>
  import JudgeMeRatingWidget from "./JudgeMeRatingWidget.svelte";
  import BikeFeatures from "./BikeFeatures.svelte";
  import ProductCardVariantButtons from "./ProductCardVariantButtons.svelte";
  import formatMoney from "../../utils/currency";
  import ProductCardStockLabel from "./ProductCardStockLabel.svelte";

  export let product;
  export let parentClasses;
</script>

<div
  class="{parentClasses}">
  <div class="flex flex-wrap justify-between xl:space-x-2 z-20">
    <div class="w-1/2 xl:w-1/4 2xl:w-2/5 pr-1 order-1 mb-2 xl:mb-0 flex flex-col justify-between">
      <div>
        {#if product.vendor}
          <p class="text-xs font-medium uppercase tracking-widest">{product.vendor}</p>
        {/if}

        <p class="b4 font-medium mb-1">{product.title}</p>

        {#if product.variantCountLabel}
          <p class="b5 font-medium mb-2">{product.variantCountLabel}</p>
        {/if}

        <JudgeMeRatingWidget productHandle="{product.handle}" />
      </div>
    </div>
    <div class="w-full xl:w-auto xl:flex-1 order-3 xl:order-2">
      {#if product.features?.length}
        <div class="mb-3">
          <BikeFeatures
            features="{product.features}"
            classes="{'grid grid-cols-2 xl:flex xl:flex-col xl:!pr-0'}"
          />
        </div>
      {/if}
    </div>
    <div class="w-1/2 xl:w-1/4 2xl:w-auto order-2 xl:order-3 xl:flex font-bold xl:font-medium">
      <p class="text-right">
        {formatMoney(product.price)}

        {#if product.compareAtPrice}
          <span class="line-through">
            {formatMoney(product.compareAtPrice)}
          </span>
        {/if}
      </p>
    </div>
  </div>

  <div class="hidden xl:flex space-x-2 z-20">
    <div class="w-1/2 xl:w-2/5">
      <ProductCardStockLabel product="{product}" dynamic="true" />
    </div>

    {#if product.variants.length > 1}
      <div class="xl:flex flex-wrap gap-1">
        <ProductCardVariantButtons product="{product}" />
      </div>
    {/if}
  </div>
</div>
